import { createSlice } from "@reduxjs/toolkit"
import { IClientClassification } from '../models/ClientClassification'
import { IDistributionArea } from '../models/DistributionArea'
import { IPaymentTerm } from '../models/PaymentTerm'

export type IReference = {
  departmentUnitId?: string
  code: string
  name: string
  type?: string
  symbol?: string
  id?: string
  connectType?: string
  color?: string
  refCode?: string
  sentName?: string
  receivedName?: string
  paymentStatus?: string
}

export interface IGeneral {
  businessTypes: any
  loginTypes: any
  deliveryStatus: IReference[]
  discountTypes: IReference[]
  invoiceStatus: IReference[]
  invoiceTypes: IReference[]
  modules: IReference[]
  orderStatus: IReference[]
  orderTypes: IReference[]
  paymentStatus: IReference[]
  permissions: any
  deliveryDateTypes: IReference[]
  deliveryNoteStatus: IReference[]
  orderPurchaseTypes: IReference[]
  orderSalesTypes: IReference[]
  businessSectors: any
  paymentMethod: IReference[]
  pullSheetStatus: IReference[]
  paymentTermConditions: IReference[]
  zipCodes: IReference[]
  paymentTerms: IPaymentTerm[]
  distributionAreas: IDistributionArea[]
  clientClassifications: IClientClassification[]
  dashboardPieFilters: IReference[]
  menus: any
  bankAccounts: any
}

const initialState: IGeneral = {
  businessSectors: [],
  businessTypes: [],
  deliveryStatus: [],
  discountTypes: [],
  invoiceStatus: [],
  invoiceTypes: [],
  loginTypes: [],
  modules: [],
  orderStatus: [],
  orderTypes: [],
  paymentStatus: [],
  permissions: [],
  deliveryDateTypes: [],
  deliveryNoteStatus: [],
  orderPurchaseTypes: [],
  orderSalesTypes: [],
  paymentMethod: [],
  pullSheetStatus: [],
  paymentTermConditions: [],
  zipCodes: [],
  paymentTerms: [],
  distributionAreas: [],
  clientClassifications: [],
  dashboardPieFilters: [],
  menus: [],
  bankAccounts: [],
}

const generalSlice = createSlice({
  name: "general",
  initialState,
  reducers: {
    initGeneral: (state, { payload }: { payload: IGeneral }) => {
      const {
        businessSectors,
        businessTypes,
        deliveryStatus,
        discountTypes,
        invoiceStatus,
        invoiceTypes,
        loginTypes,
        modules,
        orderStatus,
        orderTypes,
        paymentStatus,
        permissions,
        deliveryDateTypes,
        deliveryNoteStatus,
        orderPurchaseTypes,
        orderSalesTypes,
        paymentMethod,
        pullSheetStatus,
        paymentTermConditions,
        zipCodes,
        paymentTerms,
        distributionAreas,
        clientClassifications,
        dashboardPieFilters,
        menus,
        bankAccounts,
      } = payload

      state.businessSectors = businessSectors
      state.businessTypes = businessTypes
      state.deliveryStatus = deliveryStatus
      state.discountTypes = discountTypes
      state.invoiceStatus = invoiceStatus
      state.invoiceTypes = invoiceTypes
      state.loginTypes = loginTypes
      state.modules = modules
      state.orderStatus = orderStatus
      state.orderTypes = orderTypes
      state.paymentStatus = paymentStatus
      state.permissions = permissions
      state.deliveryDateTypes = deliveryDateTypes
      state.deliveryNoteStatus = deliveryNoteStatus
      state.orderPurchaseTypes = orderPurchaseTypes
      state.orderSalesTypes = orderSalesTypes
      state.paymentMethod = paymentMethod
      state.pullSheetStatus = pullSheetStatus
      state.paymentTermConditions = paymentTermConditions
      state.zipCodes = zipCodes
      state.paymentTerms = paymentTerms
      state.distributionAreas = distributionAreas
      state.clientClassifications = clientClassifications
      state.dashboardPieFilters = dashboardPieFilters
      state.menus = menus
      state.bankAccounts = bankAccounts

      return state
    },

    updateBusinessSectors: (state, { payload }: { payload: any }) => {
      state.businessSectors = payload

      return state
    },
  },
})

export const generalReducer = generalSlice.reducer

export const { initGeneral, updateBusinessSectors } = generalSlice.actions
